import React from "react";
import { useTranslation } from "react-i18next";
import BlockGridRow, { BlockGridRowStyles } from "../technical/BlockGridRow.jsx";
import Button, { ButtonStyles } from "./Button.jsx";

// Heplers
import { Currency2Symbol } from "../../../../constant/currencies.js";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function OffersSellingPlansStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .offers-selling-plans": {
            overflow: "auto",

            "& .plan": {
                [MobileBreakpoint]: {
                    "--n": 1,
                    transform: "translate(calc(var(--i, 0)/var(--n)*-100% + 40px + var(--tx, 0px)))",
                    transition: "transform .25s ease-out",
                },
            },
            "& .smooth": {
                transition: "transform .25s ease-out",
            },

            "& .row": {
                display: "grid",
                gridAutoFlow: "column",
                gridGap: "20px",

                "& .row-item": {
                    width: "278px",
                },

                "& .plan-title": {
                    fontSize: "32px",
                    fontWeight: "700",
                },

                "& .plan-description": {
                    fontSize: "16px",
                    fontWeight: "400",
                },

                "& .plan-cost": {
                    fontSize: "44px",
                    fontWeight: "400",
                },

                "& .plan-price-period": {
                    fontSize: "14px",
                    fontWeight: "400",
                },

                "& .plan-button": {
                    display: "grid",
                    padding: "30px 20px",
                    justifyContent: "center",
                },

                "& .plan-separator": {
                    width: "100%",
                    height: "1px",
                },

                "& .plan-feature": {
                    display: "grid",
                    gridGap: "10px",
                    padding: "20px 18px",
                    alignContent: "flex-start",
                },
            },

            // ----- Variant 1 -----
            "& .plan-variant-1": {
                "& .plan-title": {
                    padding: "20px 0",
                },

                "& .plan-description": {
                    padding: "0 18px",
                },

                "& .plan-cost": {
                    padding: "10px 0 0 0",
                },

                [MobileBreakpoint]: {
                    marginLeft: "30px",
                },
            },

            // ----- Variant 2 -----
            "& .plan-variant-2": {
                "& .plan-title": {
                    padding: "30px 0",
                },

                "& .plan-description": {
                    padding: "0 18px",
                },

                "& .plan-cost": {
                    padding: "20px 0 0 0",
                },

                [MobileBreakpoint]: {
                    marginLeft: "30px",
                },
            },

            // ----- Variant 3 -----
            "& .plan-variant-3": {
                "& .plan-description": {
                    padding: "0 18px",
                },

                "& .plan-3-header": {
                    display: "grid",
                    gridAutoFlow: "column",
                },

                "& .plan-3-title": {
                    padding: "30px 0 20px 18px",
                    fontSize: "24px",
                    fontWeight: "700",
                },

                "& .plan-3-cost": {
                    padding: "30px 18px 20px 0",
                    fontSize: "24px",
                    fontWeight: "400",
                },

                [MobileBreakpoint]: {
                    marginLeft: "30px",
                },
            },

            [MobileBreakpoint]: {
                overflow: "hidden",
            },
        },

        ...BlockGridRowStyles(params),
        ...ButtonStyles(params),
    };
}

export default function OffersSellingPlans(props) {
    const LI = useLoremIpsum();
    const { BusinessGoal, Offers, PaymentType } = props.variables;

    if (BusinessGoal !== "selling-plans") {
        return null;
    }

    const { t } = useTranslation();

    function btnText(button) {
        let text = LI.Offers[0].button;

        if (button) {
            text = button;
        } else if (!button) {
            text = {
                subscribe: t("Subscribe"),
                purchase: t("Buy"),
            }[PaymentType];
        }

        return text;
    }

    React.useEffect(() => {
        // To set childrens lenght
        const domPlans = document.querySelector(".plan"),
            N = Offers?.length;
        domPlans.style.setProperty("--n", N);

        domPlans.addEventListener("mousedown", lock, false);
        domPlans.addEventListener("touchstart", lock, false);

        domPlans.addEventListener("mouseup", move, false);
        domPlans.addEventListener("touchend", move, false);

        //domPlans.addEventListener("mousemove", drag, false);
        //domPlans.addEventListener("touchmove", drag, false);

        //  Initial coordinate
        let x0 = null;

        let locked = false;

        // To detect touch or mouse move
        function unify(e) {
            return e.changedTouches ? e.changedTouches[0] : e;
        }

        // Touchstart / MouseDown
        function lock(e) {
            x0 = unify(e).clientX;
            domPlans.classList.toggle("smooth", !(locked = true));
        }

        // TouchEnd / MouseUp
        let i = 0;

        function move(e) {
            if (!locked) {
                return;
            }
            let dx = unify(e).clientX - x0,
                s = Math.sign(dx);

            if ((i > 0 || s < 0) && (i < N - 1 || s > 0)) domPlans.style.setProperty("--i", (i -= s));
            domPlans.style.setProperty("--tx", "0px");
            domPlans.classList.toggle("smooth", !(locked = false));
            x0 = null;
        }

        // TouchMove / MouseMove
        //function drag(e) {
        //    if (x0 || x0 === 0) domPlans.style.setProperty("--tx", `${Math.round(unify(e).clientX - x0)}px`);
        //}
    }, []);

    const variant = props.variant || 1;
    const SellingPlans = //
        props?.reverse //
            ? [...(Offers || LI.Offers)].reverse()
            : Offers || LI.Offers;

    if (!Array.isArray(SellingPlans)) {
        console.warn("Selling plans is not array!");
        return null;
    }

    return (
        <div className="offers-selling-plans grid-gap-16 text-center">
            <BlockGridRow>
                {variant === 1 && (
                    <div className={`plan-variant-${variant} plan`}>
                        <div className="row">
                            {SellingPlans?.map(({ cost, currency }, index) => (
                                <div className="plan-cost row-item bg-visible" key={index}>
                                    {Currency2Symbol[currency] || LI.Offers[0].currency}
                                    {cost || LI.Offers[0].cost}

                                    {PaymentType === "subscribe" && (
                                        <div className="plan-price-period">{t("month")}</div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ title }, index) => (
                                <div className="plan-title row-item bg-visible" key={index}>
                                    {title || LI.Offers[0].title}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ description }, index) => (
                                <div className="plan-description row-item bg-visible" key={index}>
                                    {description || LI.Offers[0].description}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ button, buttonLink }, index) => {
                                return (
                                    <div className="plan-button row-item bg-visible" key={index}>
                                        <Button
                                            key={index}
                                            className={["without-gradient", "primary"]}
                                            link={buttonLink}
                                            text={btnText(button)}
                                        />
                                    </div>
                                );
                            })}
                        </div>

                        <div className="row">
                            <div className="plan-separator row-item bg-visible bg-visible-reverse"></div>
                        </div>

                        <div className="row">{OffersSellingPlansFeatures({ SellingPlans })}</div>
                    </div>
                )}

                {variant === 2 && (
                    <div className={`plan-variant-${variant} plan`}>
                        <div className="row">
                            {SellingPlans?.map(({ title }, index) => (
                                <div className="plan-title row-item bg-visible" key={index}>
                                    {title || LI.Offers[0].title}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ description }, index) => (
                                <div className="plan-description row-item bg-visible" key={index}>
                                    {description || LI.Offers[0].description}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ cost, currency }, index) => (
                                <div className="plan-cost row-item bg-visible" key={index}>
                                    {Currency2Symbol[currency] || LI.Offers[0].currency}
                                    {cost || LI.Offers[0].cost}

                                    {PaymentType === "subscribe" && (
                                        <div className="plan-price-period">{t("month")}</div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ button, buttonLink }, index) => (
                                <div className="plan-button row-item bg-visible" key={index}>
                                    <Button
                                        key={index}
                                        className={["without-gradient", "primary"]}
                                        link={buttonLink}
                                        text={btnText(button)}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            <div className="plan-separator row-item bg-visible bg-visible-reverse"></div>
                        </div>

                        <div className="row">{OffersSellingPlansFeatures({ SellingPlans })}</div>
                    </div>
                )}

                {variant === 3 && (
                    <div className={`plan-variant-${variant} plan`}>
                        <div className="row">
                            {SellingPlans?.map(({ title, cost, currency }, index) => (
                                <div className="plan-3-header row-item bg-visible" key={index}>
                                    <div className="plan-3-title">{title || LI.Offers[0].title}</div>

                                    <div className="plan-3-cost">
                                        {cost || LI.Offers[0].cost}
                                        {Currency2Symbol[currency] || LI.Offers[0].currency}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ description }, index) => (
                                <div className="plan-description row-item bg-visible" key={index}>
                                    {description || LI.Offers[0].description}
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            {SellingPlans?.map(({ button, buttonLink }, index) => (
                                <div className="plan-button row-item bg-visible" key={index}>
                                    <Button
                                        key={index}
                                        className={["without-gradient", "primary"]}
                                        link={buttonLink}
                                        text={btnText(button)}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="row">
                            <div className="plan-separator row-item bg-visible bg-visible-reverse"></div>
                        </div>

                        <div className="row">{OffersSellingPlansFeatures({ SellingPlans })}</div>
                    </div>
                )}
            </BlockGridRow>
        </div>
    );
}

function OffersSellingPlansFeatures(props) {
    const LI = useLoremIpsum();

    return props.SellingPlans?.map(({ features }, index) => {
        let _features = features || LI.Offers[0].features;

        if (typeof _features === "string") {
            _features = _features.split("\n");
        }

        _features = _features.map(l => l.trim());

        return (
            <div className="plan-feature row-item bg-visible" key={index}>
                {_features.map((feature, index) => (
                    <div key={index}>{feature || LI.Offers[0].features}</div>
                ))}
            </div>
        );
    });
}
